var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 211",
    d: "M4 23L4 35L38 35L38 23",
    stroke: "#026094",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow 2",
    d: "M20 27C20 27.5523 20.4477 28 21 28C21.5523 28 22 27.5523 22 27L20 27ZM21.7071 8.29289C21.3166 7.90237 20.6834 7.90237 20.2929 8.29289L13.9289 14.6569C13.5384 15.0474 13.5384 15.6805 13.9289 16.0711C14.3195 16.4616 14.9526 16.4616 15.3431 16.0711L21 10.4142L26.6569 16.0711C27.0474 16.4616 27.6805 16.4616 28.0711 16.0711C28.4616 15.6805 28.4616 15.0474 28.0711 14.6569L21.7071 8.29289ZM22 27L22 9L20 9L20 27L22 27Z",
    fill: "#026094"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.1b752abdae8e29788a03aaf449247631.svg";
export { ForwardRef as ReactComponent };